import { Badge } from '@/components/ui/badge';
import type { TradeType } from '../types/import-tracking.types';

const TRADE_TYPE_CONFIG: Record<TradeType, { label: string; className: string }> = {
  IMPORT: { label: '🛬 Import', className: 'border-info-borde text-primary' },
  EXPORT: { label: '🛫 Export', className: 'border-alerta-borde text-alerta' },
};

interface TradeTypeBadgeProps {
  /** Tipo de operación. Si viene undefined se asume IMPORT (retrocompat con órdenes viejas). */
  tradeType?: TradeType | null;
  className?: string;
}

export function TradeTypeBadge({ tradeType, className }: TradeTypeBadgeProps) {
  const config = TRADE_TYPE_CONFIG[tradeType ?? 'IMPORT'] ?? TRADE_TYPE_CONFIG.IMPORT;

  return (
    <Badge variant="outline" className={`${config.className} ${className ?? ''}`}>
      {config.label}
    </Badge>
  );
}
